import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const SettingLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #374151;
  margin: 4px 0px;
`;

const TextArea = ({ id, name, label, value, error, onChange, ...props }) => {
  const classNames = cx('form-field', { error });

  return (
    <div className={classNames}>
      <SettingLabel htmlFor={name}>{label}</SettingLabel>
      <textarea
        id={id || name}
        name={name}
        value={value || ''}
        onChange={onChange}
        placeholder={props.placeholder || ''}
        {...props}
      />
      {error ? <span className="validation-error">{error}</span> : null}
    </div>
  );
};

TextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default TextArea;
